import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import KontentItemLogoTile from "./kontentItemLogoTile";
import LogoGrid from "../components/logoGrid/logoGrid";

const KontentItemLogoTileSection = ({ data: { elements } }) => {
  if (!elements) {
    return null;
  }

  return (
    <LogoGrid
      headline={elements.headline.value}
      description={elements.description.value}
      deactivateButtons={elements.deactivate_item_limit.value[0]?.codename === "true"}
    >
      {elements.logo_tiles.value.map(
        (child) => <KontentItemLogoTile data={child} key={child.id} />,
      )}
    </LogoGrid>
  );
};

export const query = graphql`
  fragment KontentItemLogoTileSection on kontent_item_logo_tile_section {
    id
    system {
      codename
    }
    elements {
      headline {
        value
      }
      description {
        value
      }
      deactivate_item_limit {
        value {
          codename
        }
      }
      logo_tiles {
        value {
          ...KontentItemLogoTile
        }
      }
    }
  } 
`;

KontentItemLogoTileSection.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemLogoTileSection;
